<script setup lang="ts">
import { onMounted, ref } from 'vue';
import {
  getRegisterPresentationData,
  imageUrl,
} from 'src/modules/User/views/useGetRegisterPresentationData';
import type { ApiRegisterPresentationRegisterPresentation } from 'src/types/contentTypes';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import type { AxiosError } from 'axios';

const { locale } = useI18n();

const router = useRouter();

const data = ref<ApiRegisterPresentationRegisterPresentation>();
onMounted(async () => {
  try {
    // Load data without awaiting to avoid blocking the mount flow
    data.value = await getRegisterPresentationData(locale.value);
  } catch (e) {
    const errorMessage =
      (e as AxiosError).status === 404
        ? `Failed to load presentation data for locale ${locale.value}`
        : (e as AxiosError).message;
    void router.push({ name: 'users.register' });
    throw new Error(errorMessage, { cause: e });
  }
});
// interface Props {
//   // moduleValue: string
// }

// defineProps<Props>()

// defineEmits<{
//   // (event: 'update:moduleValue', payload: string): void
// }>()
</script>

<template>
  <div class="presentation-container">
    <picture
      v-if="data"
      class="background-image"
    >
      <img
        :src="`${imageUrl('imageMobile', 'original')}`"
        alt="Presentation"
        @click="router.push({ name: 'users.register' })"
      />
    </picture>
    <div
      v-else
      class="skeleton-container"
    >
      <q-skeleton
        height="100%"
        width="100%"
        square
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.presentation-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-image {
  position: relative;
  width: 100%;
  height: auto;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.skeleton-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.action-btn {
  position: absolute;
  bottom: 3.5rem;
  right: 2.2rem;
  z-index: 10;
  min-width: 10em;
  max-width: fit-content;
  padding-inline: 1.5em;
  font-size: clamp(0.875rem, 1.4vw, 1.5rem);
}
</style>
